import { useEffect } from "react";

/**
 * Lightweight SEO helper — sets document.title, meta description,
 * Open Graph tags, and one or more JSON-LD blobs per page.
 * `jsonLd` accepts a single object or an array.
 */
export const useSEO = ({ title, description, jsonLd }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let tag = document.querySelector(`meta[${attr}="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");

    // Remove any prior page-level JSON-LD scripts we injected
    document
      .querySelectorAll('script[data-page-jsonld="true"]')
      .forEach((n) => n.remove());

    const blobs = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
    blobs.forEach((blob, i) => {
      const tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.dataset.pageJsonld = "true";
      tag.id = `page-jsonld-${i}`;
      tag.textContent = JSON.stringify(blob);
      document.head.appendChild(tag);
    });
  }, [title, description, jsonLd]);
};
